module.exports = __webpack_public_path__ + "img/nodata.c5783094.svg";